<template>
  <transition name="page" mode="out-in">
    <nav class="col-md-2 d-none d-md-block bg-dark sidebar">
      <div class="sidebar-sticky">
        
        <div v-if="user && user.role == 4" class="p-2">
          <select v-model="selectCompany" class="form-control" @change="changeCompany">
            <option :value="null">Välj kund</option>
            <option v-for="company in companies" :key="company.id" :value="company.id">
              {{ company.name }}
            </option>
          </select>
        </div>

        <ul class="nav mt-3 flex-column">
          <li class="nav-item">
            <router-link 
              :to="{ path: '/home' }" 
              class="nav-link align-items-center">
                <fa :icon="['fal','home']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('start') }}</span>
            </router-link>

            <template v-if="user.role > 2">
              <router-link 
                :to="{ path: '/printables', query: { company_id : company.id, only_status : 'unconfirmed', type: 'unconfirmed' }}" 
                class="nav-link align-items-center mb-3 text-danger">
                  <fa :icon="['fal','stopwatch']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('unconfirmed') }}</span> <span class="nav-badge bg-danger">{{ my_audits.unconfirmed }}</span>
              </router-link>

              <router-link 
                :to="{ path: '/printables', query: { company_id : company.id, inhouse_auditor_id : user.id, type: 'inhouse_approvals' }}" 
                class="nav-link align-items-center">
                  <fa :icon="['fal','user-check']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('my_audits') }}</span> <span class="nav-badge">{{ my_audits.all }}</span>
              </router-link>

              <router-link 
                :to="{ path: '/printables', query: { company_id : company.id, inhouse_auditor_id : user.id, only_current: 1, type: 'current_inhouse_approvals' }}" 
                class="nav-link align-items-center">
                  <fa :icon="['fal','user-clock']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('my_current_audits') }}</span> <span class="nav-badge">{{ my_audits.current }}</span>
              </router-link>
            </template>
            <template v-else>
              <router-link 
                :to="{ path: '/printables', query: { company_id : company.id, auditor_id : user.id, type: 'approvals' }}" 
                class="nav-link align-items-center">
                  <fa :icon="['fal','user-check']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('my_audits') }}</span> <span class="nav-badge">{{ my_audits.all }}</span>
              </router-link>

              <router-link 
                :to="{ path: '/printables', query: { company_id : company.id, auditor_id : user.id, only_current: 1, type: 'current_approvals' }}" 
                class="nav-link align-items-center">
                  <fa :icon="['fal','user-clock']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('my_current_audits') }}</span> <span class="nav-badge">{{ my_audits.current }}</span>
              </router-link>
            </template>

            <router-link 
              :to="{ path: '/printables', query: { company_id : company.id, user_id : user.id, type: 'my_printables' }}" 
              class="nav-link mb-3 align-items-center">
                <fa :icon="['fal','user-tag']" class="mr-2" fixed-width/> <span class="flex-grow-1">{{ $t('my_printables') }}</span> <span class="nav-badge">{{ my_audits.mine }}</span>
            </router-link>
          </li>
        </ul>

        <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
          <span>{{ $t('printables') }}</span>
          <a class="d-flex align-items-center text-muted" href="#" @click="toggle('printable_types')">
            <fa :icon="['fas',  expand.printable_types ? 'caret-down' : 'caret-left']" fixed-width style="font-size: 1rem"/>
          </a>
        </h6>
        <ul class="nav flex-column" v-if="expand.printable_types">
          <li class="nav-item">
            <router-link 
              :to="{ path: '/printables', query: { company_id : company.id, type: 'all_printables' }}" 
              class="nav-link">
                {{ $t('all_printables') }} <span class="nav-badge">{{ printable_types_total() }}</span>
            </router-link>

            <router-link 
              v-for="printable_type in printable_types" 
              :key="printable_type.id" 
              :to="{ path: '/printables', query: { printable_type: printable_type.id, company_id : company.id, type: 'printable_type' + printable_type.id }}" 
              class="nav-link" :title="printable_type.name">
                <span class="text-truncate">{{ printable_type.name }}</span>
                <span class="nav-badge">{{ printable_type.printable_count }}</span>
            </router-link>
          </li>
        </ul>

        <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
          <span>Projekt</span>
          <a class="d-flex align-items-center text-muted" href="#" @click="toggle('projects')">
            <fa :icon="['fas', expand.projects ? 'caret-down' : 'caret-left']" fixed-width style="font-size: 1rem"/>
          </a>
        </h6>
        <ul class="nav flex-column" v-if="expand.projects">
          <li class="nav-item">
            <router-link 
              v-for="project in projects" 
              :key="project.id" 
              :to="{ path: '/printables', query: { project: project.id, company_id : company.id, type: 'projects' + project.id}}" 
              class="nav-link with-bullet" :title="project.name">
                <span class="text-truncate">
                  <fa :icon="['fas','circle']" class="status" :class="'text-' + (project.active ? 'success' : 'danger')" transform="shrink-8 left-2" />
                  {{ project.name }}
                </span>
                <span class="nav-badge">{{ project.printable_count }}</span>
            </router-link>
          </li>
        </ul>

        <template v-if="user.role > 2">
        <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
          <span>KOMPONENTER</span>
          <a class="d-flex align-items-center text-muted" href="#" @click="toggle('categories')">
            <fa :icon="['fas',  expand.categories ? 'caret-down' : 'caret-left']" fixed-width style="font-size: 1rem"/>
          </a>
        </h6>
        <ul class="nav flex-column" v-if="expand.categories">
          <category-item v-for="(category) in categories" :key="category.id" :category="category" :company="company" :is-sidebar="true" />
          <li>
            <router-link :to="{'name':'admin.categories.create'}" class="ml-4 mt-2 mb-2 btn btn-xs btn-outline-primary">
                  <fa :icon="['fal','plus']" />
                  Skapa ny kategori
            </router-link>
          </li>
        </ul>
        </template>
      </div>
    </nav>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from "~/components/Navbar";
import CategoryItem from '~/components/CategoryItem.vue';
import CategoryModal from '~/components/CategoryModal.vue';

export default {
  name: "Sidebar",
  components: {
    Navbar, CategoryItem, CategoryModal
  },
  created(){
    this.$store.dispatch('sidebar/fetchCompanies');

    this.setCompany(this.user.company_id);

    this.isExpanded('categories');
    this.isExpanded('projects');
    this.isExpanded('printable_types');
  },
  data(){

    return {
      selectCompany : null,
      expand : {
        'categories' : false,
        'printable_types' : false,
        'projects' : false
      }
    }
  },
  watch : {
    company(n,o){
      if(n.id){
        this.selectCompany = n.id;
      }
    },
    sidebar(n,o){

    },
  },
  computed: mapGetters({
    user: 'auth/user',
    categories: 'sidebar/categories',
    company: 'auth/company',
    companies: 'sidebar/companies',
    printable_types: 'sidebar/printable_types',
    projects: 'sidebar/projects',
    my_audits: 'sidebar/my_audits'
  }),
  methods : {
    activeClass(active){
      return 'text-' + (active ? 'success' : 'danger');
    },
    toggle(section){
      this.expand[section] = !this.expand[section];
      this.$store.dispatch('sidebar/setExpanded',{id:section});
    },
    printable_types_total(){
      var items = this.printable_types;
      
      if(items){
        return items.reduce((prevVal, pt) => prevVal + pt.printable_count, 0); 
      } else {
        return 0
      }
    },
    changeCompany(){
      if(this.selectCompany){
        let company_id = this.selectCompany;
        
        this.setCompany(company_id);
      } 
    },
    setCompany(company_id){
      this.$store.dispatch('auth/updateCompany',company_id);

      if(this.$route.query.company_id){
        let query = JSON.parse(JSON.stringify(this.$route.query));
        query.company_id = company_id;

        this.$router.replace({ query: query });
      }

      this.fetchSidebar(company_id)
    },
    fetchSidebar(company_id){
      this.$store.dispatch('sidebar/fetchSidebar',company_id);
    },
    isExpanded(id){
        let expanded = this.$store.getters['sidebar/expanded'];
        this.expand[id] = expanded.includes(id);

        return this.expand[id];
    }
  }
};
</script>

<style lang="scss" scoped>
  
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/Sidebar.vue